import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { getProfile, isCorporate } from '../utils/auth'

export const useRequireAuth = () => {
  const history = useHistory()
  useEffect(() => {
    if (!getProfile()?.token) history.replace('/')
  }, [history])
}

/** Redirect corporate users away from RH pages */
export const useRhGuard = () => {
  const history = useHistory()
  useEffect(() => {
    const profile = getProfile()
    if (!profile?.token) {
      history.replace('/')
      return
    }
    if (isCorporate()) history.replace('/corporate/dashboard')
  }, [history])
}

/** Redirect RH-only users away from corporate pages (admin + corporate allowed) */
export const useCorporateGuard = () => {
  const history = useHistory()
  useEffect(() => {
    const profile = getProfile()
    if (!profile?.token) {
      history.replace('/')
      return
    }
    if (profile?.result?.role === 'user') history.replace('/dashboard')
  }, [history])
}
